/**
 * A selectable list row (the file-groups picker, so far) — MUI's own default
 * is a flat `rgba(0,0,0,.08)` grey for `.Mui-selected`, unrelated to this
 * app's palette. Matches the same "one clean highlight" the Autocomplete
 * option list uses: `--surface-hover` for hover, `--accent-surface` for
 * selected, a stronger accent tint when both apply at once.
 */
import type { Components, Theme } from '@mui/material/styles';

export const MuiListItemButton: Components<Theme>['MuiListItemButton'] = {
	styleOverrides: {
		root: {
			/* MUI's own resting state has no border or fill at all — invisible
         until hovered or selected, which reads as "unstyled" next to this
         app's bordered inputs and cards. A hairline row (matching the
         table's own row rule, "hairline rows, not zebra") gives every item
         a visible edge even at rest. */
			borderBottom: '1px solid var(--line)',
			'&:last-of-type': {
				borderBottom: 'none',
			},
			'&:hover': {
				backgroundColor: 'var(--surface-hover)',
			},
			'&.Mui-selected': {
				backgroundColor: 'var(--accent-surface)',
				'&:hover': {
					backgroundColor: 'var(--accent-border)',
				},
			},
		},
	},
};
